module.exports = __webpack_public_path__ + "static/img/preview-orange-with-progress-bar.d4a27e04.png";